/**
 * Tournament visibility for groups/apartments (Firebase).
 * User can see a tournament if they are in any of the tournament's groupIds (or apartmentIds)
 * and are approved for that group. Uses approvedGroupIds (synced from groupMembers).
 */
export function userApprovedGroupIds(userProfile) {
  if (!userProfile) return [];
  return Array.isArray(userProfile.approvedGroupIds) ? userProfile.approvedGroupIds : [];
}

export function tournamentVisibleToUser(tournament, userProfile) {
  if (!tournament) return false;
  const vis = tournament.visibility || 'open';
  if (vis === 'open') return true;
  const approvedIds = userApprovedGroupIds(userProfile);
  if (vis === 'groups') {
    const gIds = tournament.groupIds || [];
    return gIds.length > 0 && gIds.some(g => approvedIds.includes(g));
  }
  if (vis === 'apartments') {
    const aptIds = tournament.apartmentIds || [];
    return aptIds.length > 0 && aptIds.some(a => approvedIds.includes(a));
  }
  return false;
}
